<ng-container *ngIf="item.navCap">
  <div mat-subheader class="nav-caption"> {{ item.navCap }} </div>
</ng-container>
<ng-container *ngIf="item.separator">
  <mat-divider class="nav-menu-separator"></mat-divider>
</ng-container>
<ng-container *ngIf="!item.separator && !item.navCap && !item.external && !item.twoLines">
  <a mat-list-item
    (click)="onItemSelected(item)"
    [ngClass]="{
      'mat-toolbar mat-primary activeMenu': item.route
        ? router.isActive(item.route, true)
        : false,
      expanded: expanded,
      disabled: item.disabled
    }"
    class="menu-list-item {{ item.bgcolor }}">
    <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
    <span class="hide-menu">{{ item.displayName | translate }}</span>
    <ng-container *ngIf="item.children && item.children.length">
      <span class="arrow-icon" fxFlex>
        <span fxFlex></span>
        <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'"> expand_more</mat-icon>
      </span>
    </ng-container>
    <ng-container *ngIf="item.chip">
      <span>
        <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill">{{ item.chipContent }}</span>
      </span>
    </ng-container>
  </a>
</ng-container>
    
<!-- external Link -->
<ng-container *ngIf="!item.navCap && item.external">
  <a mat-list-item
    (click)="openExternalLink('//google.com')"
    class="menu-list-item {{ item.bgcolor }}"
    target="_blank">
    <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
    <span class="hide-menu">{{ item.displayName | translate }}</span>
  </a>
</ng-container>
  
<!-- children -->
<ng-container *ngIf="expanded">
  <div>
    <ng-container *ngFor="let child of item.children;">
      <mat-divider *ngIf="child.separator" class="nav-menu-separator"></mat-divider>
      <app-nav-item
        *ngIf="!child.separator"
        [item]="child"
        (click)="onSubItemSelected(child)"
        [depth]="depth + 1">
      </app-nav-item>
    </ng-container>
  </div>
</ng-container>